import React from 'react';
import { Link } from "react-router-dom";
import Separator from '../../elements/separator/Separator';

const Nav = () => {
    return (
        <ul className="mainmenu">
            <li className="has-droupdown"><Link to="/">Home</Link></li>
            <li><Link to="/about-us">About</Link></li>
            <li><Link to="/portfolio">Portfolio</Link></li>
            <li className="with-megamenu"><Link to="#">Services</Link>
                <div className="rn-megamenu">
                    <div className="wrapper">
                        <div className="row row--0">
                            {/* Web Development */}
                            <div className="col-lg-3 single-mega-item">
                                <ul className="mega-menu-item" style={{ marginTop: '-1rem', marginBottom: '3rem' }}>
                                    <li><h5 style={{ paddingLeft: '2rem' }}>WEB DEVELOPMENT</h5></li>
                                    <div style={{ marginTop: '-1rem', marginBottom: '0.5rem' }}><Separator /></div>
                                    <li><Link to="/our-services/web-development/wordpress-development/">WordPress Development</Link></li>
                                    <li><Link to="/our-services/web-development/shopify-web-development/">Shopify Web Development</Link></li>
                                    <li><Link to="/our-services/web-development/angularjs-development/">AngularJS Development</Link></li>
                                    <li><Link to="/our-services/web-development/dotnet-development/">.NET Development</Link></li>
                                    <li><Link to="/our-services/web-development/full-stack-development-with-next-js/">Next.js Full-Stack Development</Link></li>
                                    <li><Link to="/our-services/web-development/website-maintenance/">Website Maintenance</Link></li>
                                    <li><Link to="/our-services/web-development/laravel-development/">Laravel Development</Link></li>


                                </ul>
                            </div>

                            {/* Mobile App Solutions */}
                            <div className="col-lg-3 single-mega-item">
                                <ul className="mega-menu-item" style={{ marginTop: '-1rem', marginBottom: '3rem' }}>
                                    <li><h5 style={{ paddingLeft: '2rem' }}>MOBILE APP SOLUTIONS</h5></li>
                                    <div style={{ marginTop: '-1rem', marginBottom: '0.5rem' }}><Separator /></div>
                                    <li><Link to="/our-services/mobile-app-solutions/mobile-app-development/">Mobile App Development</Link></li>
                                    <li><Link to="/our-services/mobile-app-solutions/custom-app-development/">Custom App Development</Link></li>
                                    <li><Link to="/our-services/mobile-app-solutions/progressive-web-apps/">Progressive Web Apps</Link></li>
                                    <li><Link to="/our-services/mobile-app-solutions/cross-platform-development/">Cross Platform Development</Link></li>

                                    <div style={{ marginTop: '3rem' }}>
                                        <li><h5 style={{ paddingLeft: '2rem' }}>GAME DEVELOPMENT</h5></li>
                                        <div style={{ marginTop: '-1rem', marginBottom: '0.5rem' }}><Separator /></div>
                                        <li><Link to="/our-services/game-development/game-development/">Game Development</Link></li>
                                    </div>

                                </ul>
                            </div>

                            {/* Digital Marketing */}
                            <div className="col-lg-3 single-mega-item">
                                <ul className="mega-menu-item" style={{ marginTop: '-1rem', marginBottom: '3rem' }}>
                                    <li><h5 style={{ paddingLeft: '2rem' }}>DIGITAL MARKETING & SEO</h5></li>
                                    <div style={{ marginTop: '-1rem', marginBottom: '0.5rem' }}><Separator /></div>
                                    <li><Link to="/our-services/digital-marketing/seo/">Search Engine Optimization</Link></li>


                                    <div style={{ marginTop: '3rem' }}>
                                        <li><h5 style={{ paddingLeft: '2rem' }}>ENTERPRISE SOLUTIONS</h5></li>
                                        <div style={{ marginTop: '-1rem', marginBottom: '0.5rem' }}><Separator /></div>
                                        <li><Link to="/our-services/ai-ml-solutions/ai-ml-solutions/">AI & ML Solutions</Link></li>
                                        <li><Link to="/our-services/enterprise-solutions/crm/">CRM</Link></li>
                                        <li><Link to="/our-services/enterprise-solutions/erp/">ERP</Link></li>
                                    </div>
                                </ul>
                            </div>

                            {/* Design & Editing */}
                            <div className="col-lg-3 single-mega-item">
                                <ul className="mega-menu-item" style={{ marginTop: '-1rem', marginBottom: '3rem' }}>
                                    <li><h5 style={{ paddingLeft: '2rem' }}>DESIGN & EDITING</h5></li>
                                    <div style={{ marginTop: '-1rem', marginBottom: '0.5rem' }}><Separator /></div>
                                    <li><Link to="/our-services/our-services/web-design/video-editing/">Video Editing</Link></li>
                                    <li><Link to="/our-services/our-services/web-design/ui-ux-design/">UI/UX Design</Link></li>
                                    <li><Link to="/our-services/graphic-design/logo-design/">Logo Design</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    );
}

export default Nav;
